import { render, staticRenderFns } from "./LevyEstimator.vue?vue&type=template&id=965b1e3c&"
import script from "./LevyEstimator.vue?vue&type=script&lang=js&"
export * from "./LevyEstimator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports